import { assign, setup } from 'xstate';

import { resetConfirmation, setConfirmation } from './actions';
import { ConfirmationEvents } from './events';
import { ConfirmationContext, ConfirmationInput } from './types';

/**
 * Confirmation View Machine
 * - Handles Confirmation View popup which needs user input before proceeding, such as a delete confirmation
 */

export const confirmationView = setup({
  types: {
    context: {} as ConfirmationContext,
    events: {} as ConfirmationEvents,
    input: {} as ConfirmationInput,
  },
  actions: {
    setConfirmation: assign(setConfirmation),
    resetConfirmation: assign(resetConfirmation),
  },
}).createMachine({
  id: 'confirmationView',
  context: ({ input }): ConfirmationContext => ({
    show: false,
    title: '',
    message: '',
    confirmLabel: 'Yes',
    tone: 'destructive',
    onConfirm: input.onConfirm || (() => undefined),
    onCancel: input.onCancel || (() => undefined),
    ...input,
  }),
  initial: '$_HIDDEN',
  on: {
    ON_SHOW_CONFIRMATION: {
      actions: ['setConfirmation'],
      target: '.$_SHOWING',
    },
    // Session boundary: drop the text and the callbacks of whatever was on screen.
    ON_RESET_CONFIRMATION: {
      actions: ['resetConfirmation'],
      target: '.$_HIDDEN',
    },
  },
  states: {
    $_HIDDEN: {},
    $_SHOWING: {
      on: {
        ON_CLOSE_CONFIRMATION: {
          target: '$_HIDDEN',
        },
      },
    },
  },
});
